import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table'; // api

import { getLogsLogisticsTerminalUnfinished } from '../../api/statsAPI';
import { getAreaTerminals } from '../../api/areaAPI'; // redux

import { setLogisticsTerminalUnfinished, setLogisticsTerminalUnfinishedSort } from '../../redux/line-dashboard';
var t = i18n.getFixedT(null, 'line-dashboard');
var gt = i18n.getFixedT(null, 'app');
var LogisticsTerminalListTable = /*#__PURE__*/React.memo(function () {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$lineDash = _useSelector.lineDashboard,
      logisticsTerminalUnfinished = _useSelector$lineDash.logisticsTerminalUnfinished,
      logisticsTerminalUnfinishedSort = _useSelector$lineDash.logisticsTerminalUnfinishedSort,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      curZoneId = _useState2[0],
      setCurZoneId = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      curTerminalId = _useState4[0],
      setCurTermianlId = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      currentPage = _useState8[0],
      setCurrentPage = _useState8[1];

  var _useState9 = useState(10),
      _useState10 = _slicedToArray(_useState9, 2),
      rowsPerPage = _useState10[0],
      setRowsPerPage = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      terminalsList = _useState12[0],
      setTerminalsList = _useState12[1];

  var isMounted = useRef(false);

  var handleSort = function handleSort(sort) {
    dispatch(setLogisticsTerminalUnfinishedSort(sort));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return '';
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var fetchData = function fetchData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getLogsLogisticsTerminalUnfinished(contextRoot, false, curZoneId, curTerminalId, logisticsTerminalUnfinishedSort, offset, rowsPerPage).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result);

      _.map(newData.content, function (el, index) {
        el.sequence = offset + index + 1;
      });

      dispatch(setLogisticsTerminalUnfinished(newData));
    });
  };

  useEffect(function () {
    if (isMounted.current) {
      fetchData();
    }
  }, [curTerminalId, JSON.stringify(logisticsTerminalUnfinishedSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (isMounted.current) {
      if (curZoneId === '') {
        setTerminalsList([]);
      } else {
        getAreaTerminals(contextRoot, true, curZoneId, null, 0, null, null, true).then(function (result) {
          var tList = _.map(result.content, function (el) {
            return {
              value: el.id,
              text: el.name
            };
          });

          setTerminalsList(tList);
        });
      }

      if (_.isEmpty(curTerminalId)) {
        fetchData();
      } else {
        setCurTermianlId('');
      }
    }
  }, [curZoneId]);
  useEffect(function () {
    if (isMounted.current && logisticsTerminalUnfinished.totalElements !== totalCount) setTotalCount(logisticsTerminalUnfinished.totalElements);
  }, [JSON.stringify(logisticsTerminalUnfinished)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'deliverType', {
    label: t('lbl-container-deliver-types'),
    sortable: true,
    formatter: function formatter(val, row) {
      return val ? t('lbl-' + val.toUpperCase()) : '';
    }
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailerPlateNo'),
    sortable: true
  });

  _.set(fields, 'transportType', {
    label: t('lbl-transport-type'),
    sortable: true
  });

  _.set(fields, 'containerType', {
    label: t('lbl-container-type'),
    sortable: true
  });

  _.set(fields, 'containerNo', {
    label: t('lbl-container-number'),
    sortable: true
  });

  _.set(fields, 'oriTerminalName', {
    label: t('lbl-ori-terminal'),
    sortable: true
  });

  _.set(fields, 'dstTerminalName', {
    label: t('lbl-dst-terminal'),
    sortable: true
  });

  _.set(fields, 'logisticName', {
    label: t('lbl-logistic-name'),
    sortable: true
  }); // _.set(fields, 'driverNationId', { label: t('lbl-driver-nation-id'), sortable:true })


  _.set(fields, 'estBeginTime', {
    label: t('lbl-est-begin-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'oriZoneOutTime', {
    label: t('lbl-ori-zone-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstZoneInTime', {
    label: t('lbl-dst-zone-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalInTime', {
    label: t('lbl-dst-terminal-in-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'dstTerminalOutTime', {
    label: t('lbl-dst-terminal-out-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "logisticsList-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-terminal-deliver-worklist')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-zone-center'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-zones-center'),
    list: zonesList,
    value: curZoneId,
    onChange: function onChange(value) {
      setCurZoneId(value);
      setCurrentPage(0);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminals'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: curTerminalId,
    onChange: function onChange(value) {
      setCurTermianlId(value);
      setCurrentPage(0);
    },
    width: '186px'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    enableTextWordWrap: true,
    fields: fields,
    data: logisticsTerminalUnfinished.content ? logisticsTerminalUnfinished.content : '',
    sort: logisticsTerminalUnfinishedSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
});
export default LogisticsTerminalListTable;